module.exports = __webpack_public_path__ + "static/otoai-fc5c8596b5192b41128173eae797cc75.png";